import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useAddTeamsMutation } from "../Features/teams/teamsApi";

const TeamsModal = ({ control, modal }) => {
    const [teamName, setTeamName] = useState("");
    const [description, setDescription] = useState("");
    const [color, setColor] = useState("");

    const [addTeams, { data, isLoading, error }] = useAddTeamsMutation();

    const { accessToken, user } = useSelector((state) => state.auth);

    const HandleCreateTeam = async (e) => {
        e.preventDefault();
        await addTeams({
            members: [
                {
                    id: 1,
                    email: user?.email,
                },
            ],
            name: teamName,
            description,
            timestamp: new Date().getTime(),
            color,
        });
        control();
        setColor("");
        setDescription("");
        setTeamName("");
    };

    return (
        modal && (
            <>
                <div
                    className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
                    onClick={control}
                ></div>
                <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Create Team
                    </h2>
                    <form
                        className="mt-8 space-y-6"
                        onSubmit={HandleCreateTeam}
                    >
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="name" className="sr-only">
                                    Name
                                </label>
                                <input
                                    id="name"
                                    name="to"
                                    type="text"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                                    placeholder="Team name"
                                    value={teamName}
                                    onChange={(e) =>
                                        setTeamName(e.target.value)
                                    }
                                />
                            </div>
                            <div>
                                <label htmlFor="color" className="sr-only">
                                    Color
                                </label>
                                <select
                                    id="color"
                                    name="to"
                                    type="text"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                                    placeholder="Choose a team color"
                                    value={color}
                                    onChange={(e) => setColor(e.target.value)}
                                >
                                    <option value="">Choose a color</option>
                                    <option value="green">Green</option>
                                    <option value="yellow">Yellow</option>
                                    <option value="red">Red</option>
                                </select>
                            </div>
                            <div>
                                <label
                                    htmlFor="description"
                                    className="sr-only"
                                >
                                    Description
                                </label>
                                <textarea
                                    id="description"
                                    name="message"
                                    type="text"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                                    placeholder="Description"
                                    value={description}
                                    onChange={(e) =>
                                        setDescription(e.target.value)
                                    }
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                            >
                                Create
                            </button>
                        </div>
                    </form>
                </div>
            </>
        )
    );
};

export default TeamsModal;
